export const ADD_LOADED_COMPONENT = 'cm/ADD_LOADED_COMPONENT';
